(function(){
  'use strict';

  /* ---- mobile nav ---- */
  var nav = document.getElementById('mnav');
  document.addEventListener('click', function(e){
    var open = e.target.closest('[data-mnav-open]');
    var close = e.target.closest('[data-mnav-close]');
    if (open && nav) { nav.classList.add('open'); document.body.style.overflow = 'hidden'; }
    if (close && nav) { nav.classList.remove('open'); document.body.style.overflow = ''; }
  });

  /* ---- product gallery ---- */
  document.addEventListener('click', function(e){
    var t = e.target.closest('[data-thumb]');
    if (!t) return;
    var main = document.getElementById('galMain');
    if (main) main.src = t.getAttribute('data-full');
    document.querySelectorAll('[data-thumb]').forEach(function(b){ b.classList.remove('on'); });
    t.classList.add('on');
  });

  /* ---- quantity ---- */
  document.addEventListener('click', function(e){
    var b = e.target.closest('[data-qty]');
    if (!b) return;
    var box = b.closest('.qty');
    var input = box.querySelector('input');
    var val = parseInt(input.value || '1', 10);
    input.value = b.getAttribute('data-qty') === 'up' ? val + 1 : Math.max(1, val - 1);
  });

  /* ---- variant picker ---- */
  document.querySelectorAll('[data-variant-form]').forEach(function(form){
    var data = form.querySelector('[data-variant-json]');
    if (!data) return;

    var variants;
    try { variants = JSON.parse(data.textContent); } catch (err) { return; }
    if (!variants || !variants.length) return;

    var idField  = form.querySelector('[name="id"]');
    var priceNow = form.querySelector('[data-price-now]');
    var priceWas = form.querySelector('[data-price-was]');
    var priceOff = form.querySelector('[data-price-off]');
    var addBtn   = form.querySelector('[data-add-btn]');
    var opts     = form.querySelectorAll('[data-opt]');

    /* Single-variant products have no option inputs — nothing to sync. */
    if (!opts.length) return;

    var fmt = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'INR';
    function money(cents){
      try {
        return new Intl.NumberFormat('en-IN', { style: 'currency', currency: fmt, minimumFractionDigits: 2 }).format(cents / 100);
      } catch (err) {
        return '₹' + (cents / 100).toFixed(2);
      }
    }

    function update(){
      var chosen = Array.prototype.map.call(form.querySelectorAll('[data-opt]:checked'), function(i){ return i.value; });
      if (!chosen.length) return;

      var match = null;
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i];
        var ok = true;
        for (var j = 0; j < chosen.length; j++) {
          if (v.options[j] !== chosen[j]) { ok = false; break; }
        }
        if (ok) { match = v; break; }
      }

      if (!match) {
        if (addBtn) { addBtn.disabled = true; addBtn.textContent = 'Unavailable'; }
        return;
      }

      if (idField) idField.value = match.id;
      if (priceNow) priceNow.textContent = money(match.price);

      var discounted = match.compare_at_price && match.compare_at_price > match.price;
      if (priceWas) {
        priceWas.textContent = discounted ? money(match.compare_at_price) : '';
        priceWas.style.display = discounted ? '' : 'none';
      }
      if (priceOff) {
        priceOff.textContent = discounted ? Math.round((1 - match.price / match.compare_at_price) * 100) + '% OFF' : '';
        priceOff.style.display = discounted ? '' : 'none';
      }
      if (addBtn) {
        addBtn.disabled = !match.available;
        addBtn.textContent = match.available ? addBtn.getAttribute('data-label') : 'Sold out';
      }

      var img = document.getElementById('galMain');
      if (img && match.featured_image && match.featured_image.src) img.src = match.featured_image.src;
    }

    form.addEventListener('change', function(e){ if (e.target.matches('[data-opt]')) update(); });
    update();
  });

  /* ---- quiz ---- */
  document.addEventListener('click', function(e){
    var q = e.target.closest('[data-quiz-go]');
    if (!q) return;
    var href = q.getAttribute('data-quiz-go');
    if (!href || href === '#') return;
    e.preventDefault();
    window.location.href = href;
  });

  /* ---- collection sort ---- */
  document.querySelectorAll('[data-sort]').forEach(function(s){
    s.addEventListener('change', function(){
      var u = new URL(window.location.href);
      u.searchParams.set('sort_by', s.value);
      u.searchParams.delete('page');
      window.location.href = u.toString();
    });
  });

})();
